import { DynamicTile } from "./dynamic-tile";

export class ColumnDashboardDefinition {
    constructor(public leftSide: Array<DynamicTile>, public rightSide: Array<DynamicTile>) { }
}